import CommentBoxRoot from './CommentBoxRoot';
import CommentBoxRootV2 from '../../lego.editor_comment/CommentBoxRoot';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CommentBoxRootV2
})(CommentBoxRoot);

//# sourceMappingURL=index.js.map